// this is an autogenerated file from App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/AcknowledgePlatformFee/Content/AcknowledgedBy/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_PaymentProviders_Accounts_Content_ProviderAccount_AcknowledgePlatformFee_Content_AcknowledgedBy($end_date: date!, $current_location_id: uuid!) {
  users(
    where: {
      vaxiom_user: {
        person: {
          employment_contracts: {
            _and: [
              {
                _or: [
                  { employment_end_date: { _is_null: true } }
                  { employment_end_date: { _gte: $end_date } }
                ]
              }
              {
                employee_resources: {
                  invalid: { _eq: false }
                  resource: {
                    organization: { _id: { _eq: $current_location_id } }
                  }
                }
              }
            ]
          }
        }
      }
    }
    order_by: { vaxiom_person: { search_name: asc } }
  ) {
    id
    vaxiom_user_id
    email
    vaxiom_person {
      id
      first_name
      middle_name
      last_name
    }
  }
}

`